import { Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function PermissionMatrixSettings() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6 max-w-2xl">
      <div className="flex items-center gap-3">
        <button
          onClick={() => navigate(-1)}
          className="text-sm text-muted-foreground hover:text-foreground"
        >
          &larr; Back
        </button>
        <h1 className="text-2xl font-bold text-foreground">Permission Matrix</h1>
      </div>

      <div className="rounded-lg border bg-card text-card-foreground shadow-sm p-8 text-center">
        <Shield className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
        <h2 className="text-lg font-semibold mb-2">Coming Soon</h2>
        <p className="text-sm text-muted-foreground">
          The permission matrix editor will be available in a future update.
        </p>
      </div>
    </div>
  );
}
